import React from 'react';
import { get } from 'lodash/fp';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { SHIPPING_CARRIERS } from 'enums/shipping-carrier-enums';
import { FONTS } from 'styles/theme/fonts';
import { COLORS } from 'styles/theme/colors';

const TrackingLink = ({ row }) => {
  const carrier = get('carrier')(row);
  const code = get('trackingCode')(row);
  const url = get('trackingCodeUrl')(row);

  const carrierDisplayName = get(`[${carrier}].displayName`)(SHIPPING_CARRIERS) || carrier;

  return code && carrier ? (
    <TrackingLink.Styled target="_blank" rel="noopener noreferrer" href={url}>
      {`${carrierDisplayName}  #${code}`}
    </TrackingLink.Styled>
  ) : (
    <TrackingLink.Dash />
  );
};

TrackingLink.Styled = styled.a`
  font-family: ${FONTS.default};
  text-decoration: none;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  text-transform: uppercase;
  color: ${COLORS.primaryText};
  padding: 3px 0px;
  border-bottom: 1px solid ${COLORS.primaryLinkBorder};

  &:hover {
    color: ${COLORS.primaryText};
    text-decoration: none;
  }
`;

TrackingLink.Dash = styled.div`
  border-bottom: 1px solid ${COLORS.primaryLinkBorder};
  width: 60px;
`;

TrackingLink.propTypes = {
  row: PropTypes.shape({
    trackingCode: PropTypes.string,
    trackingCodeUrl: PropTypes.string,
  }),
};

export default TrackingLink;
